import React, { Suspense } from "react";
import PropTypes from "prop-types";

const Staffbar = React.lazy(() => import(/* webpackChunkName: "spa_staffbar" */ "apps/staffbar"));

const LazyStaffbar = ({ isStaff }) => (
	<Suspense fallback={null}>
		{isStaff && <Staffbar />}
	</Suspense>
);

LazyStaffbar.propTypes = {
	isStaff: PropTypes.bool.isRequired,
};

export default LazyStaffbar;



// WEBPACK FOOTER //
// ./src/routers/shared/components/LazyStaffbar.jsx